import {Center, CenterProps, Image, ScaleFade, VStack} from '@chakra-ui/react'
import image_logo from './logo_loading.png'
import Sponsor from './Sponsor'

const LoadingAnimation = (props: CenterProps) => {
  return (
    <Center w='full' {...props}>
      <VStack p={0} maxW='500px' w='500px' alignContent='center' pos='relative' spacing={8}>
        {/* use only image for now with animation fade-in out (to 20%) */}
        <ScaleFade in={true} unmountOnExit={true} initialScale={0.9}>
          <Image
            src={image_logo}
            alt='Forum Prix de Lausanne'
            width={500}
            height={500}
            style={{
              objectFit: 'contain',
            }}
          />
        </ScaleFade>

        <Sponsor />
      </VStack>
    </Center>
  )
}

export default LoadingAnimation
